export class FacturaPagarModel {
  factura: string;
  importe: number;
  remesando: boolean;
}
